import { render, staticRenderFns } from "./replyList.vue?vue&type=template&id=d2f3d2ee&scoped=true&"
import script from "./replyList.vue?vue&type=script&lang=ts&"
export * from "./replyList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f3d2ee",
  null
  
)

export default component.exports